<div fxLayout="column" *ngIf="status === 2 && qrCode !== undefined" fxFlexFill fxLayoutAlign="center center" class="div-status confirmed"
  fxLayoutGap="7px">
  <img alt="img" height="45" width="45" [src]="'data:image/jpeg;base64,'+qrCode" />
</div>
<div fxLayout="column" *ngIf="status === 2 && qrCode === undefined" fxFlexFill fxLayoutAlign="center center" class="div-status confirmed"
  fxLayoutGap="7px">
  <img alt="img" class="img-status" src="assets/icons/Approved.svg" />
  <span class="text-confirmed medium">{{'approved'|transloco}}</span>
</div>
<div fxLayout="column" *ngIf="status === 4" fxFlexFill fxLayoutAlign="center center" class="div-status expired"
  fxLayoutGap="7px">
  <img alt="img" class="img-status" src="assets/icons/expired.svg" />
  <span class="textsmalldark medium">{{'expired'|transloco}}</span>
</div>
<div fxLayout="column" *ngIf="status === 3" fxFlexFill fxLayoutAlign="center center" class="div-status rejected"
  fxLayoutGap="7px">
  <img alt="img" class="img-status" src="assets/icons/rejected.svg" />
  <span class="text-rejected medium">{{'rejected'|transloco}}</span>
</div>
<div fxLayout="column" *ngIf="status === 1" fxFlexFill fxLayoutAlign="center center" class="div-status pending"
  fxLayoutGap="7px">
  <img alt="img" class="img-status" src="assets/icons/pendingnew.svg" />
  <span class="text-pending medium">{{'pending'|transloco}}</span>
</div>
